<div #wrapper class="pr-notification" [ngClass]="display" (click)="close()">
  <div class="pr-notification-header">
    <div class="pr-notification-timeout"></div>
  </div>
  <div class="pr-notification-body">
    <pr-icon class="pr-notification-icon" [name]="icon"></pr-icon>
    <div class="pr-notification-content">
      <div class="pr-notification-title">{{ title }}</div>
      <div class="pr-notification-description">{{ description }}</div>
    </div>
  </div>
</div>
